import {filterArrayUndefined} from '@coolcolduk/util';
import type {Study} from '@cp/model';
import {mapStudyDbToType} from '@cp/model';
import {getDocs} from 'firebase/firestore';
import {getStudyCollection} from './getStudyCollection';
import getStudyDocValidated from './getStudyDocValidated';

export default async function listStudiesDoc(moduleId: string, topics?: string[]): Promise<Study[]> {
  if (topics && topics.length > 0) {
    const results = await Promise.all(topics.map((topic) => getStudyDocValidated(moduleId, topic)));
    return results;
  }
  const snapshot = await getDocs(getStudyCollection(moduleId));
  return filterArrayUndefined(snapshot.docs.map((d) => mapStudyDbToType(d)) ?? []);
}
